import { IndustryConfig } from './industry-config.interface';
import { IndustryType } from './industry-types.enum';

/**
 * Retail Industry Configuration
 * Standard POS configuration - baseline functionality
 */
export const RetailIndustryConfig: IndustryConfig = {
    industryType: IndustryType.RETAIL,
    name: 'Retail',
    apiPathSegment: null, // Retail uses base API paths without modification
    features: {
        enableFreeQuantity: false,
        enableMapping: false,
        enableVariants: false,
        enableTableManagement: false,
        enableKitchenDisplay: false,
        productSearchFields: [],
        orderPlacementFields: [],
    },
};
